/**
 * v92.7.0 · BodyPortal
 * Renderiza su contenido directamente en <body>, fuera de cualquier tarjeta, columna o panel
 * con overflow/transform. Así los menús, wizards y modales nunca quedan cortados ni debajo del fondo.
 */
import { createPortal } from "react-dom";

export default function BodyPortal({ children }) {
  if (typeof document === "undefined") return children;
  return createPortal(children, document.body);
}
